import React from "react";
import Contact from "./Contact";
import About from "./About";
import Intro from "./Intro";
import "./App.css";

class Home extends React.Component {
  render() {
    return (
      <div>
        <Intro />
        <section>
          <h2 className="aboutme-header animate fade-in-from-bottom">About Me</h2>
          <About />
        </section>
        <section>
          <Contact />
        </section>
      </div>
    );
  }
}

export default Home;
